import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigatorComponent } from './navigator.component';
// import { NavigatorService } from './navigator.service';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [NavigatorComponent],
  imports: [CommonModule, RouterModule],
  // providers: [NavigatorService],
  exports: [NavigatorComponent],
})
export class NavigatorModule {}
